import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// SELDON_BEATTIE_DELETE_ATTACHMENT

const mutation = gql`
  mutation wellnessSeldonBeattieFormDeleteAttachment($id: ID!) {
    wellnessSeldonBeattieFormDeleteAttachment(id: $id) {
      id
      form_attachment {
        id
      }
    }
  }
`

export default function useWellnessDeleteAttachment() {
  const { onMutate: onWellnessAttachmentDelete, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'wellnessSeldonBeattieFormDeleteAttachment',
    successMessage: 'Attachment deleted'
  })

  return { onWellnessAttachmentDelete, loading }
}
